Payment Breakdeowen

<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Sites">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="onChangeSites">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Payment Type">
                                <a-select v-model="inputPaymentType" showSearch placeholder="All Payment Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="onChangePaymentType">
                                    <a-select-option v-for="option in payment_type_options" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <base-checkbox class="mb-3" v-model="include_trans_id">
                        Include Trans ID
                    </base-checkbox>
 
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: [],
                paymentBreakdownReport: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                JsonData: [],
                inputTransType: 0,
                filterStatus: 0,
                transactionTypes: [],
                include_trans_id: false,
                inputPaymentType: 0,
                payment_type_options: [],
                debit_and_credit_tender_type: [],
                is_debit_or_credit_card: false,
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            component_x.payment_type_options = payment_types;
            component_x.payment_type_options.push({id: 0, code: 'all', name: ' All Payment Types'})
            component_x.sort(component_x.payment_type_options);

            var tender_types = await HTTPRequest.getRequest(component_x.endPoint + "tender_types/get_valid_tender_types", null);
            const targetTypes = ['DEBIT CARD', 'CREDIT CARD'];
            component_x.debit_and_credit_tender_type = tender_types
                .filter(t => targetTypes.includes(t.name))
                .map(t => t.id);
            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.inputTransType = 0

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToUpperCase(data){
                let uppercasedData = data.toUpperCase();
                return uppercasedData
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'payment_breakdown?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&include_trans_id=' + this.include_trans_id + '&payment_type=' + this.inputPaymentType, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                if(this.inputPaymentType == 0) this.is_debit_or_credit_card = true;

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    // let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'b3' });
                
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let headers = [];
                    let detailColStyles = {
                            0: {cellWidth: 50},
                            1: {cellWidth: 50},
                            2: {cellWidth: 30},
                            3: {cellWidth: 20},
                            4: {cellWidth: 40},
                            5: {cellWidth: 40},
                            6: {cellWidth: 25}
                    };
                    if(this.include_trans_id){
                        if(this.is_debit_or_credit_card){
                            detailColStyles = {
                                0: {cellWidth: 45},
                                1: {cellWidth: 45},
                                2: {cellWidth: 30},
                                3: {cellWidth: 20},
                                4: {cellWidth: 15},
                                5: {cellWidth: 40},
                                6: {cellWidth: 40},
                                7: {cellWidth: 35},
                                8: {cellWidth: 35},
                                9: {cellWidth: 25}
                            } 
                        } else {
                            detailColStyles = {
                                0: {cellWidth: 45},
                                1: {cellWidth: 45},
                                2: {cellWidth: 30},
                                3: {cellWidth: 20},
                                4: {cellWidth: 15},
                                5: {cellWidth: 40},
                                6: {cellWidth: 35},
                                7: {cellWidth: 25}
                            } 
                        }
                    }
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    if (!this.include_trans_id) {
                        headers.push(
                            {content: 'Site', styles: {halign: 'center'}},
                            {content: 'Terminal', styles: {halign: 'center'}},
                            {content: 'Business Date', styles: {halign: 'center'}},
                            {content: 'Payment Type ID', styles: {halign: 'center'}},
                            {content: 'Payment Type Name', styles: {halign: 'center'}},
                            {content: 'Tender Type', styles: {halign: 'center'}},
                            {content: 'Amount', styles: {halign: 'center'}}
                        )
                    } else {
                        if(!this.is_debit_or_credit_card){
                            headers.push(
                                {content: 'Site', styles: {halign: 'center'}},
                                {content: 'Terminal', styles: {halign: 'center'}},
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Trans No', styles: {halign: 'center'}},
                                {content: 'Payment Type ID', styles: {halign: 'center'}},
                                {content: 'Payment Type Name', styles: {halign: 'center'}},
                                {content: 'Tender Type', styles: {halign: 'center'}},
                                {content: 'Amount', styles: {halign: 'center'}}
                            )
                        } else {
                            headers.push(
                                {content: 'Site', styles: {halign: 'center'}},
                                {content: 'Terminal', styles: {halign: 'center'}},
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Trans No', styles: {halign: 'center'}},
                                {content: 'Payment Type ID', styles: {halign: 'center'}},
                                {content: 'Payment Type Name', styles: {halign: 'center'}},
                                {content: 'Reference Number', styles: {halign: 'center'}},
                                {content: 'Reference Name', styles: {halign: 'center'}},
                                {content: 'Tender Type', styles: {halign: 'center'}},
                                {content: 'Amount', styles: {halign: 'center'}}
                            )
                        }
                    }
                    

                    for(var x=0; x < siteSpecific.length; x++){
                        let grand_total = 0
                        this.paymentBreakdownReport = siteSpecific[x].report_details

                        if(x > 0 && this.paymentBreakdownReport.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        // report headers
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        let design_y = 20
                        // design_y = design_y + 5;
                        doc.text(15,design_y,`Payment Breakdown Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        design_y = design_y + 10;
                        doc.text(15,design_y,"Site: " + siteSpecific[x].report_details[0].site)


                        this.paymentBreakdownReport = siteSpecific[x].report_details
                        // report data
                        if(this.paymentBreakdownReport.length > 0){
                            for(let i=0; i < this.paymentBreakdownReport.length; i++){
                                let reportLine = this.paymentBreakdownReport[i]
                                let detail = [];
                                if (!this.include_trans_id){
                                    detail = [
                                        {content: reportLine.site, styles: {halign: 'left'}},
                                        {content: reportLine.terminal, styles: {halign: 'left'}},
                                        {content: moment(reportLine.business_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                        {content: reportLine.payment_type_id, styles: {halign: 'right'}},
                                        {content: reportLine.payment_type_name, styles: {halign: 'left'}},
                                        {content: reportLine.tender_type, styles: {halign: 'left'}},
                                        {content: this.convertToCurrency(Number(reportLine.amount)), styles: {halign: 'right'}},
                                    ]
                                } else {
                                    if(this.is_debit_or_credit_card){
                                        detail = [
                                            {content: reportLine.site, styles: {halign: 'left'}},
                                            {content: reportLine.terminal, styles: {halign: 'left'}},
                                            {content: moment(reportLine.business_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                            {content: reportLine.transaction_number, styles: {halign: 'right'}},
                                            {content: reportLine.payment_type_id, styles: {halign: 'right'}},
                                            {content: reportLine.payment_type_name, styles: {halign: 'left'}},
                                            {content: reportLine.reference_number, styles: {halign: 'left'}},
                                            {content: reportLine.reference_name, styles: {halign: 'left'}},
                                            {content: reportLine.tender_type, styles: {halign: 'left'}},
                                            {content: this.convertToCurrency(Number(reportLine.amount)), styles: {halign: 'right'}},
                                        ]
                                    } else {
                                        detail = [
                                            {content: reportLine.site, styles: {halign: 'left'}},
                                            {content: reportLine.terminal, styles: {halign: 'left'}},
                                            {content: moment(reportLine.business_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                            {content: reportLine.transaction_number, styles: {halign: 'right'}},
                                            {content: reportLine.payment_type_id, styles: {halign: 'right'}},
                                            {content: reportLine.payment_type_name, styles: {halign: 'left'}},
                                            {content: reportLine.tender_type, styles: {halign: 'left'}},
                                            {content: this.convertToCurrency(Number(reportLine.amount)), styles: {halign: 'right'}},
                                        ]
                                    }
                                }
                
                                grand_total += Number(reportLine.amount)
                                reportData.push(detail)
                                
                                // let subtotal_detail = []
                                let grand_total_detail = []
                                if(i == this.paymentBreakdownReport.length-1){
                                    if (!this.include_trans_id){
                                        grand_total_detail = ['','','','','',
                                            {content: 'Total: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                            {content: this.convertToCurrency(grand_total), styles: {fontStyle: 'bold'}}
                                        ]
                                    } else {
                                        if(this.is_debit_or_credit_card){
                                            grand_total_detail = ['','','','','','','','',
                                                {content: 'Total: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                                {content: this.convertToCurrency(grand_total), styles: {fontStyle: 'bold'}}
                                            ]
                                        } else {
                                            grand_total_detail = ['','','','','','',
                                                {content: 'Total: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                                {content: this.convertToCurrency(grand_total), styles: {fontStyle: 'bold'}}
                                            ]
                                        }
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(grand_total_detail)

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    // subtotal = 0
                                    // grand_total = 0
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Payment Breakdown Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'payment_breakdown?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&include_trans_id=' + this.include_trans_id + '&payment_type=' + this.inputPaymentType, null);
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                if(this.inputPaymentType == 0) this.is_debit_or_credit_card = true;
                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        let headers = []
                        this.paymentBreakdownReport = siteSpecific[x].report_details
                        if (!this.include_trans_id) {
                            headers = ['Site', 'Terminal', 'Business Date', 'Payment Type ID', 'Payment Type Name', 'Tender Type', 'Amount']
                        } else {
                             if(!this.is_debit_or_credit_card){
                                headers = ['Site', 'Terminal', 'Business Date', 'Trans No', 'Payment Type ID', 'Payment Type Name', 'Tender Type', 'Amount']
                             } else {
                                headers = ['Site', 'Terminal', 'Business Date', 'Trans No', 'Payment Type ID', 'Payment Type Name', 'Reference Number', 'Reference Name', 'Tender Type', 'Amount']
                             }
                        }
                        let reportData = []
                        if(this.paymentBreakdownReport.length > 0){
                            let grand_total = 0
                            for(let i=0; i < this.paymentBreakdownReport.length; i++){
                                let reportLine = this.paymentBreakdownReport[i]
                                let detail = [];
                                if (!this.include_trans_id) {
                                    detail = [
                                        reportLine.site,
                                        reportLine.terminal,
                                        moment(reportLine.business_date).format("YYYY-MM-DD"),
                                        reportLine.payment_type_id,
                                        reportLine.payment_type_name,
                                        reportLine.tender_type,
                                        this.convertToCurrency(Number(reportLine.amount))
                                    ]
                                } else {
                                     if(!this.is_debit_or_credit_card){
                                        detail = [
                                            reportLine.site,
                                            reportLine.terminal,
                                            moment(reportLine.business_date).format("YYYY-MM-DD"),
                                            reportLine.transaction_number,
                                            reportLine.payment_type_id,
                                            reportLine.payment_type_name,
                                            reportLine.tender_type,
                                            this.convertToCurrency(Number(reportLine.amount))
                                        ]
                                    } else {
                                        detail = [
                                            reportLine.site,
                                            reportLine.terminal,
                                            moment(reportLine.business_date).format("YYYY-MM-DD"),
                                            reportLine.transaction_number,
                                            reportLine.payment_type_id,
                                            reportLine.payment_type_name,
                                            reportLine.reference_number,
                                            reportLine.reference_name,
                                            reportLine.tender_type,
                                            this.convertToCurrency(Number(reportLine.amount))
                                        ]
                                    }
                                }

                                grand_total += Number(reportLine.amount)
                                reportData.push(detail)
                                
                                let grand_total_detail = []
                                if(i == this.paymentBreakdownReport.length-1){
                                    if (!this.include_trans_id) {
                                        grand_total_detail = ['', '', '', '', '', 'Total: ', this.convertToCurrency(grand_total)]
                                } else {
                                     if(!this.is_debit_or_credit_card){
                                       grand_total_detail = ['', '', '', '', '', '', 'Total: ', this.convertToCurrency(grand_total)]
                                    } else {
                                        grand_total_detail = ['', '', '', '', '', '', '', '', 'Total: ', this.convertToCurrency(grand_total)]
                                    }
                                }
                                    reportData.push(grand_total_detail)
                                } else {
                                    //     sub_qty = 0
                                    //     sub_gross = 0
                                    //     sub_net = 0
                                    // }   
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Site: " + siteSpecific[x].report_details[0].site])
                        reportData.push(["Payment Breakdown Report", "", "", "Generated By: " + printed_by])
                        reportData.push(["For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            async onChangeSites(value){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + value, null);
                this.terminalOptions = terminals;
                this.sort(this.terminalOptions);
            },
            async onChangePaymentType(value){
                const selectedPayment = this.payment_type_options.find(p => p.id === value);
                if (selectedPayment || value == 0) {
                    this.is_debit_or_credit_card = this.debit_and_credit_tender_type.includes(selectedPayment.tender_type_id);
                } else {
                    this.is_debit_or_credit_card = false;
                }
            }
        }
    };
</script>

<style></style>